import { BookOpen, ArrowRight, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';

const Guides = () => {
  return (
    <section id="guides" className="py-20 bg-gradient-to-br from-dark-card to-dark-bg">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-block mb-4">
              <BookOpen className="w-12 h-12 text-toxic-green" />
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              Guide des <span className="text-toxic-green">Paris en Ligne</span>
            </h2>
            <p className="text-xl text-gray-400">
              Tout ce que vous devez savoir pour commencer à parier en toute sécurité en France
            </p>
          </div>

          <div className="bg-dark-card border-2 border-gray-800 rounded-2xl p-8 md:p-12 relative overflow-hidden">
            {/* Hexagonal decoration */}
            <div className="absolute top-0 right-0 w-32 h-32 border-2 border-toxic-green opacity-10 rotate-45 transform translate-x-16 -translate-y-16"></div>
            <div className="absolute bottom-0 left-0 w-24 h-24 border-2 border-toxic-green opacity-10 rotate-45 transform -translate-x-12 translate-y-12"></div>

            <div className="relative z-10">
              <div className="flex items-start mb-6">
                <FileText className="w-6 h-6 text-toxic-green mr-4 mt-1 flex-shrink-0" />
                <div>
                  <h3 className="text-2xl font-bold mb-4 text-white">
                    Comment Parier en Ligne en France
                  </h3>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Le marché français des paris en ligne est régulé par l'Autorité Nationale des Jeux (ANJ). Pour parier légalement, vous devez choisir une plateforme agréée qui respecte les normes de sécurité et de protection des joueurs.
                  </p>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Avant de commencer, créez un compte sur une plateforme agréée, vérifiez votre identité, et profitez des bonus de bienvenue. Chaque site propose différents types de paris : sportifs, hippiques, ou les deux. Choisissez selon vos préférences.
                  </p>
                  <p className="text-gray-300 leading-relaxed mb-6">
                    N'oubliez pas de jouer de manière responsable. Fixez-vous des limites de dépôt et de temps, et ne pariez jamais plus que ce que vous pouvez vous permettre de perdre.
                  </p>
                </div>
              </div>

              <Link
                to="/guides"
                data-discover="true"
                className="inline-flex items-center px-6 py-3 bg-toxic-green text-dark-bg font-bold rounded-lg hover:bg-opacity-80 transition-all group"
              >
                Consulter Tous les Guides
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Guides;

